import { render, staticRenderFns } from "./BaseRegistrationForBusinessUserStepFour.vue?vue&type=template&id=b6e11698&"
import script from "./BaseRegistrationForBusinessUserStepFour.vue?vue&type=script&lang=js&"
export * from "./BaseRegistrationForBusinessUserStepFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports